import type { IScope } from "angular";
import { finalize } from "rxjs/operators";
import type { IProfileService } from "App/Modules/Auth";

import type { IPartnerUserSlim, IProfile, IResponseWithLoading } from "../../../../Models";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

export default class ProfilePartnersComponentController {
    public static $inject = ["$scope", "mmProfileService"];

    public profile: IProfile;

    public partners: IResponseWithLoading<IPartnerUserSlim[]>;

    constructor(private $scope: IScope, private profileService: IProfileService) {}

    public $onInit() {
        this.partners = {
            isLoading: true,
        };

        extendWithLoadingAndFail(this.profileService.getPartners())
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.partners = result;
                },
                (result) => {
                    this.partners = result;
                },
            );
    }
}
